import { filterSearchParams } from '@Queries/helpers/generateQueryKeys';

import type { Query } from '@Types/Base';

export default function getInlineBannersKeys(input: {
  slug: string;
  search: string;
  request: Query;
}) {
  const { slug, search, request } = input;
  const { region, country } = request;
  const filteredSearch = filterSearchParams(search);

  const keys = ['category-banners', { slug, country, region, filteredSearch }].filter(Boolean);

  return keys;
}
